"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    box-shadow: ", ";\n    & > div {\n      touch-action: manipulation;\n      transition: all 200ms ease-out;\n      cursor: pointer;\n      display: grid;\n      align-items: center;\n      padding: ", "px ", "px;\n      background-color: ", ";\n      min-height: 40px;\n      grid-template-columns: repeat(", ", auto);\n      &:hover {\n        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n        transform: scale(1,1);\n      }\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

exports.StyledTable = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 3 : _ref$columns;
  return styled_components_1.css(_templateObject2(), theme.shadows.boxShadow.card, theme.spacing.unit, theme.spacing.unit * 2, theme.palette.background["default"], columns);
});
exports["default"] = {};